<template>
    <div id="lineas-captura-admin">
        <div>
            <v-breadcrumbs :items="breadcrumbs">
                <v-icon slot="divider">forward</v-icon>
            </v-breadcrumbs>
        </div>

        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12>
                    <base-material-card color="primary" icon="library_books" title="Layout Confronta DS"
                        class="elevation-1 px-5 py-3">
                        <v-container fluid fill-height>
                            <v-layout align-center justify-center>
                                <v-flex xs12>
                                    <v-card>
                                        <v-card-text>
                                            <v-card-actions>

                                                <v-spacer></v-spacer>
                                                <v-speed-dial id="descargos_sd" direction="left" open-on-hover>
                                                    <template v-slot:activator>
                                                        <v-btn id="descargos_sd_btn" x-small fab dark color="primary">
                                                            <v-icon>reorder</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <exportar-excel :data="camposLayout"
                                                        :exportFields="encabezadoLayout" name="Layout_A24.xlsx">
                                                        <v-btn fab dark x-small color="purple darken-2"
                                                            title="Descargar Layout Confronta DS" v-tippy>
                                                            <v-icon dark>receipt</v-icon>
                                                        </v-btn>
                                                    </exportar-excel>
                                                    <upload-excel-component idInput="pedimentosKey"
                                                        :on-success="handleSuccess" :before-upload="beforeUpload" />
                                                </v-speed-dial>
                                            </v-card-actions>
                                            <div id="datagrid">
                                                <v-refresh-button :funcion="cargarConsultas" />
                                                <v-client-table ref="vuetable" :data="consulta.items"
                                                    :columns="consulta.columns" :options="consulta.options"
                                                    class="elevation-2 pa-2">
                                                    <template slot="noResults">
                                                        <v-alert :value="true" icon="info" color="info">No se
                                                            encontró ningun registro</v-alert>
                                                    </template>
                                                    <template slot="actions" slot-scope="props">
                                                        <div class="space">
                                                            <v-btn btn color="blue" x-small fab dark
                                                                @click.native="download_layout(props.row.key_s3)"
                                                                title="Descargar Archivo Procesado" v-tippy>
                                                                <v-icon>receipt</v-icon>
                                                            </v-btn>
                                                            <v-btn btn color="red" x-small fab dark
                                                                @click.native="eliminar(props.row._id)" title="Eliminar"
                                                                v-tippy>
                                                                <v-icon>delete</v-icon>
                                                            </v-btn>
                                                        </div>
                                                    </template>
                                                    <template slot="estatus" slot-scope="props">
                                                        {{ get_estatus(props.row.estatus) }}
                                                    </template>
                                                </v-client-table>
                                            </div>

                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </base-material-card>
                </v-flex>
            </v-layout>
        </v-container>


    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import GridLoader from "vue-spinner/src/GridLoader.vue";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
    components: {
        "v-refresh-button": RefreshButton,
        loader: GridLoader
    },
    created: function () {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.URL = this.$hostname + "reportes/";
        this.model.usuario = this.$local_storage.get("usuario");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
            this.permisoEliminar = true;
            this.model.rfc = "ADMINISTRACION";
        } else {
            this.model.rfc = this.$local_storage.get("rfc");
        }


        this.cargarConsultas();
    },
    data: () => ({
        file: "",
        file_adjunto: null,
        apivucem: "https://apivucem.econnectpro.mx",
        name_file: "",
        size_file: 0,
        type_file: 'application/zip',
        rfcs_array: [],
        show_combo_rfc: false,
        dialog1: false,
        lista_filtrada: [],
        refreshTabla: false,
        permisoEliminar: false,
        fab: false,
        elzip: "",
        breadcrumbs: [{
            text: "Inicio",
            disabled: false,
            to: "/admin"
        },
        {
            text: "Layout Confronta DS",
            disabled: true,
            to: ""
        }
        ],
        datos: [],

        modal: false,
        validaContribucion: false,
        validaForma: false,
        validaIdentificador: false,
        arr_formas_pago: [],
        arr_contribuciones: [],

        show_loading: true,

        consulta: {
            columns: ["filename", "fecha", "usuario", 'estatus', 'error', 'actions'],
            options: {
                filterable: ["fecha", "usuario", "filename", 'estatus', 'error'],
                sortable: ["fecha", "usuario"],

                headings: {
                    fecha: "Fecha de Creación",
                    usuario: "Usuario",
                    filename: "Nombre Layout",
                    actions: "Opciones"
                }
            },
            selected: [],
            items: [],
        },
        model: {
            rfc: "",
            rfc_cliente: "",
            usuario: "",
            fecha_de: "",
            fecha_a: "",
            reporte_url: "",
            nombre_reporte: "",
            tipo: "Layout_a24",
            lista: '',
        },

        menu1: false,
        menu2: false,

        rules: {
            required: v => !!v || "Este campo es requerido",
            numeric: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            }
        },
        importData: [],
        encabezadoLayout: {
            "RFC": "RFC",
            "ID": "ID",
            "Pedimento": "Pedimento",
            "Llave": "Llave",
            "FP": "FP",
            "Clave": "Clave",
            "Factura": "Factura",
            "Fraccion": "Fraccion",
            "Material": "Material",
            "Descripcion": "Descripcion",
            "USD": "USD",
            "Cantidad": "Cantidad",
            "UM": "UM",
            "CantidadUMT": "CantidadUMT",
            "UMT": "UMT",
            "Pais": "Pais",
            "Tipo": "Tipo",
        },
        camposLayout: [{
            "RFC": "[ RFC ]",
            "ID": "[ ID ]",
            "Pedimento": "[ Pedimento ]",
            "Llave": "[ Llave ]",
            "FP": "[ FP ]",
            "Clave": "[ Clave ]",
            "Factura": "[ Factura ]",
            "Fraccion": "[ Fraccion ]",
            "Material": "[ Material ]",
            "Descripcion": "[ Descripcion ]",
            "USD": "[ USD ]",
            "Cantidad": "[ Cantidad ]",
            "UM": "[ UM ]",
            "CantidadUMT": "[ Cantidad UMT ]",
            "UMT": "[ UMT ]",
            "Pais": "[ Pais ]",
            "Tipo": "[ Tipo I / E ]",
        }],
    }),

    methods: {
        uploadFile: function (file, referencia) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let rfc = this.$local_storage.get("rfc");

            var thisObj = this;

            var keyFile = rfc + "/layouts_a24/"+ moment(new Date()).format("YYYYMMDDHHmmss")+ "_" + thisObj.name_file;

            var datos = {
                key: keyFile,
                bucket: "production.econnect.ds",
                type: thisObj.type_file
            }
            axios.post(thisObj.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, file, { headers: { 'Content-Type': thisObj.type_file } })
                            .then((res) => {
                                thisObj.submitFile(referencia, keyFile);

                            })
                            .catch((error) => {
                                thisObj.$root.$dialogLoader.hide();
                                thisObj.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                    footer: '',
                                });
                                console.log(error);
                            });

                    } else {
                        thisObj.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al cargar el archivo. Favor de comunicarse con soporte.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    thisObj.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    thisObj.$root.$dialogLoader.hide();
                });


        },

        submitFile(referencia, keyFile) {
            //this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let formData = {
                filename: referencia,
                key: keyFile,
                rfc: this.$local_storage.get("rfc"),
                usuario: this.$local_storage.get("id_usuario"),
            };
            
            console.log(this.apivucem + '/vucem/save_layout_generico/');
            console.log(formData);
            return false;
            
            axios.post(this.apivucem + '/vucem/save_layout_generico/', formData)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                            footer: '',
                        });
                    }

                })
                .catch((error) => {
                    var msg = ''
                    var mostrar = true;
                    if (error.response != null) {
                        if (error.response.data.mensaje != null)
                            msg = error.response.data.mensaje[0];
                        if (error.response.data.message != null) { //Si entra aqui significa que regreso un TimeOut de Amazon Api, recibirá notificacion cuando temrine                
                            mostrar = false;
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                                footer: '',
                            });
                            msg = error.response.data.message;
                        }
                    }
                    if (mostrar) {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al cargar el archivo",
                            footer: msg,
                        });
                        console.log(error);
                    }

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.cargarConsultas()
                });

        },
        eliminar: function (id) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    var datos = {
                        _id: id,
                    }
                    axios.post(this.apivucem + '/vucem/eliminar_layout_a24/', datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente",
                                footer: ""
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro. Favor de comunicarse con soporte.",
                                footer: '',
                            });
                            console.log(error);
                        }).then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargarConsultas();
                        });
                }
            });
        },
        cargarConsultas: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let formData = {
                rfc: this.$local_storage.get("rfc"),
            };


            axios.post(this.apivucem + "/vucem/listar_layouts_a24/", formData)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.consulta.items = res.data;
                        this.consulta.items.sort(function (a, b) {
                            return new Date(b.fecha) - new Date(a.fecha);
                        });
                        for (var k in this.consulta.items) {
                            this.consulta.items[k].fecha = this.parseDate(this.consulta.items[k].fecha);
                        }
                    }
                })
                .catch(err => {

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        download_layout: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            let nombre_download = key.split("/").pop();
            axios.post(this.$hostname + "s3/download/", datos, {
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
                Allow: "POST",
                "cache-control": "no-cache",
            })
                .then(response => {
                    var bytes = this.base64ToArrayBuffer(response.data);
                    let blob = new Blob([bytes], {
                        type: response.headers["content-type"]
                    }),
                        url = window.URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = nombre_download;
                    a.click();
                    a.parentNode.removeChild(a);
                })
                .catch(error => {
                    console.log(error);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        beforeUpload(file) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var self = this;
            const isLt2M = file.size / 1024 / 1024 < 50;

            if (isLt2M) {
                this.name_file = file.name;
                this.size_file = file.size;
                this.type_file = file.type;

                const nombre = this.name_file.split(".");
                this.uploadFile(file, nombre[0]);

                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 50MB.",
                footer: ""
            });
            self.file_adjunto = null;
            return false;
        },
        handleSuccess: async function ({ results, header }) {
        },
        get_estatus: function (estatus) {
            const estatus_list = {
                "0": "Pendiente",
                "1": "En Proceso",
                "2": "Correcto",
                "3": "Error",
            };

            return estatus_list.hasOwnProperty(estatus.toString()) ? estatus_list[estatus.toString()] : "N/A";
        },
    }, //methods
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.elevation-1>>>#VueTables_th--Referencia {
    min-width: 350px !important;
}

.elevation-2>>>#VueTables_th--localizado {
    min-width: 450px !important;
}

.elevation-2>>>.columnaCriterio {
    white-space: normal !important;
    max-width: 450px !important;
    text-align: justify !important;
}

.space {
    display: flex;
    justify-content: space-between;
}
</style>